import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = ({ onSignOut }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        await onSignOut();
      } finally {
        // Always navigate to login after animation completes
        setTimeout(() => {
          navigate('/login');
        }, 2000); // Give time for the animation to play
      }
    };

    performLogout();
  }, [onSignOut, navigate]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gradient-to-b from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
      <div className="text-center">
        <div className="relative">
          {/* Outer ring */}
          <div className="w-24 h-24 rounded-full border-8 border-gray-200 dark:border-gray-700 animate-[spin_3s_linear_infinite]" />
          
          {/* Inner ring */}
          <div className="absolute inset-0 w-24 h-24 rounded-full border-8 border-transparent border-t-teal-500 dark:border-t-teal-400 animate-[spin_1.5s_linear_infinite]" />
          
          {/* Center dot */}
          <div className="absolute inset-0 m-auto w-4 h-4 bg-teal-500 dark:bg-teal-400 rounded-full animate-pulse" />
        </div>
        
        <div className="mt-8 space-y-2">
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
            Signing Out
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            Please wait while we log you out...
          </p>
        </div>

        {/* Animated dots */}
        <div className="mt-4 flex justify-center space-x-1">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="w-2 h-2 bg-teal-500 dark:bg-teal-400 rounded-full"
              style={{
                animation: `bounce 1.4s infinite ${i * 0.2}s`
              }}
            />
          ))}
        </div>
      </div>

      {/* Add keyframes for the dots animation */}
      <style jsx>{`
        @keyframes bounce {
          0%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
};

export default Logout; 